import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { TabNav } from "../../../components/tabNav";
import { PageHeader } from "../../../components/typography/pageHeader";
import { SalesOverview } from "./salesOverview";
import { SalesPerformannce } from "./salesPerformance";

type SalesTab = "overview" | "performance";

export const SalesPage = () => {
  const [tab, setTab] = useState<SalesTab>();

  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = [
    {
      title: "Overview",
      to: "overview",
      onClick: () => {
        setSearchParams({
          tab: "overview",
        });
      },
    },
    {
      title: "Performance",
      to: "performance",
      onClick: () => {
        setSearchParams({
          tab: "performance",
        });
      },
    },
  ];

  useEffect(() => {
    const activeTab = (searchParams.get("tab") ?? "overview") as SalesTab;

    setTab(activeTab);
  }, [searchParams]);

  return (
    <div className="flex w-full flex-col gap-8 md:h-full">
      <PageHeader header={"Sales"} className="!font-dela font-normal" />

      <TabNav
        navs={tabs}
        className="!min-w-full md:!min-w-fit md:!max-w-fit"
        tabClassName=""
        activeTab={tab ?? "overview"}
        variant="switcher"
        theme="plain"
      />

      {tab === "overview" ? <SalesOverview /> : undefined}

      {tab === "performance" ? <SalesPerformannce /> : undefined}
    </div>
  );
};
